var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center text-h5 primary--text d-flex dashboard-text",style:(`min-height: ${_vm.minHeight}`)},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }